exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-overlay[data-v-1f1e2e3a]{position:fixed;top:0;left:0;width:100%;height:1500px}.loading-overlay img[data-v-1f1e2e3a]{z-index:10;display:block;position:fixed;top:32%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);-webkit-transform:-webkit-translate(-50%,-50%);transform:-webkit-translate(-50%,-50%);transform:-moz-translate(-50%,-50%);transform:-ms-translate(-50%,-50%);height:100px}.loading-overlay p[data-v-1f1e2e3a]{display:block;font-size:30px}", ""]);

// exports
